import { jsxs as n, jsx as t } from "react/jsx-runtime";
const h = ({
  size: o = 36,
  color: e = "#fff",
  fillColor: r = "#0C3D3D",
  ...i
}) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 36 36",
    fill: "none",
    ...i,
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "35", height: "35", rx: "17.5", fill: r }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M24.2501 11.4502L11 24.7003M11 11.4502L24.2501 24.7003",
          stroke: e,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  h as CloseModalIcon
};
